import { useTranslation } from "react-i18next";
import { deleteMicroAppMutation, listMicroAppsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for a micro-app row/detail page. */
export function useDeleteMicroApp(onDeleted?: () => void) {
  const { t } = useTranslation("microApps");
  return useDeleteEntity<{ uuid: string; name: string }>({
    mutation: deleteMicroAppMutation(),
    listQueryKey: listMicroAppsQueryKey,
    pathFor: (a) => ({ app_uuid: a.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
